import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import packageJson from '../../package.json';

// ─────────────────────────────────────────────────────────────────────────────
// WAT IS ER NIEUW — pas dit aan bij elke release
// ─────────────────────────────────────────────────────────────────────────────
const RELEASE_TYPE = 'minor';

const RELEASE_LABELS = {
  major: { label: 'Grote release',        color: '#fff', bg: '#6366f1' },
  minor: { label: 'Nieuwe functies',      color: '#fff', bg: '#ea7211' },
  patch: { label: 'Kleine verbeteringen', color: '#fff', bg: '#16a34a' },
};

const WHATS_NEW = {
  version: packageJson.version,
  title: 'Welkom bij Mijn Webvonk',
  subtitle: 'Wijzigingen voor Koffiereparatie Geleen',
  items: [
    {
      label: 'Website statistieken toegevoegd',
      description: 'De werkende versie van website statistieken is nu beschikbaar in het dashboard.',
    },
    {
      label: 'Bug in machines wijzigen en afbeeldingen opgelost',
      description: 'Het bewerken van machines en het correct inladen van afbeeldingen werkt nu zoals verwacht.',
    },
  ],
};
// ─────────────────────────────────────────────────────────────────────────────

const STORAGE_KEY = 'koffie-whatsnew-seen';
const STORAGE_VAL = '2';

const CSS = `
  @keyframes glowDrift {
    0%   { transform: translate(0%, 0%) scale(1); }
    25%  { transform: translate(6%, -8%) scale(1.08); }
    50%  { transform: translate(-4%, 10%) scale(0.96); }
    75%  { transform: translate(-8%, -4%) scale(1.04); }
    100% { transform: translate(0%, 0%) scale(1); }
  }
  @keyframes koffie-wn-fadein {
    from { opacity: 0; transform: scale(0.97) translateY(8px); }
    to   { opacity: 1; transform: scale(1) translateY(0); }
  }
  .koffie-wn-btn {
    width: 100%;
    padding: 15px 20px;
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    color: #fff;
    border: none;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: -0.02em;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.15s, transform 0.15s;
    box-shadow: 0 2px 12px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.08);
  }
  .koffie-wn-btn:hover { opacity: 0.88; transform: translateY(-1px); }
  .koffie-wn-btn:active { opacity: 1; transform: translateY(0); }
`;

export default function KoffieWhatsNewModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // uitgeschakeld
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, STORAGE_VAL);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <style>{CSS}</style>
      <div
        onClick={dismiss}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(10,10,10,0.6)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 99998, padding: 20,
          fontFamily: 'system-ui, -apple-system, sans-serif',
          overflow: 'hidden',
        }}
      >
        <div style={{
          position: 'absolute',
          width: '70vw', height: '70vw',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.13) 0%, transparent 70%)',
          animation: 'glowDrift 18s ease-in-out infinite',
          pointerEvents: 'none',
        }} />

        <div
          onClick={e => e.stopPropagation()}
          style={{
            background: 'rgba(255,255,255,0.52)',
            backdropFilter: 'blur(48px) saturate(220%)',
            WebkitBackdropFilter: 'blur(48px) saturate(220%)',
            border: '1px solid rgba(255,255,255,0.7)',
            borderRadius: 28,
            padding: '44px 40px 36px',
            width: '100%', maxWidth: 600,
            boxShadow: '0 8px 64px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.9)',
            position: 'relative',
            animation: 'koffie-wn-fadein 0.35s cubic-bezier(0.34,1.56,0.64,1) both',
          }}
        >
          <div style={{
            display: 'inline-flex', alignItems: 'center',
            background: RELEASE_LABELS[RELEASE_TYPE].bg,
            color: RELEASE_LABELS[RELEASE_TYPE].color,
            fontSize: 12, fontWeight: 700,
            padding: '5px 12px', borderRadius: 8,
            letterSpacing: '0.02em',
            marginBottom: 14,
          }}>
            {RELEASE_LABELS[RELEASE_TYPE].label}
          </div>

          <h2 style={{
            fontSize: 28, fontWeight: 800, color: '#0a0a0a',
            letterSpacing: '-0.03em', lineHeight: 1.2, margin: '0 0 6px',
          }}>
            {WHATS_NEW.title} V{WHATS_NEW.version}
          </h2>

          <div style={{ height: 1, background: 'rgba(0,0,0,0.08)', margin: '20px 0' }} />

          <p style={{
            fontSize: 13, fontWeight: 600, color: 'rgba(0,0,0,0.45)',
            margin: '0 0 20px', textTransform: 'uppercase', letterSpacing: '0.06em',
          }}>
            {WHATS_NEW.subtitle}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 32 }}>
            {WHATS_NEW.items.map((item, i) => (
              <div key={i}>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#0a0a0a', marginBottom: 2 }}>
                  {item.label}
                </div>
                <div style={{ fontSize: 14, color: 'rgba(0,0,0,0.5)', lineHeight: 1.55 }}>
                  {item.description}
                </div>
              </div>
            ))}
          </div>

          <button className="koffie-wn-btn" onClick={dismiss}>
            Doorgaan
            <ArrowRight size={15} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </>
  );
}
